import script from "./MazdaSoVersionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaSoVersionPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaSoVersionPanel.vue?vue&type=style&index=0&id=10031e09&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10031e09"]])

export default __exports__